import { Box } from '@cp/ds/src/components/box';
import { styled } from '@cp/ds/src/theme/styled';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';

export const StepFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(2.5),
  [theme.breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD)]: {
    marginBottom: theme.spacing(6),
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
  },
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    marginTop: theme.spacing(4),
  },
}));
